import React from 'react';

const StaticPage = ({ title, content }) => (
  <div className="min-h-screen p-6 md:p-12 bg-palette3 text-palette2 max-w-4xl mx-auto">
    <h1 className="text-2xl md:text-3xl font-bold mb-6">{title}</h1>
    <div className="text-palette1 text-sm md:text-base space-y-4">
      {content}
    </div>
  </div>
);

export const Privacidad = () => <StaticPage title="Política de Privacidad" content={<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>} />;
export const Terminos = () => <StaticPage title="Términos y Condiciones" content={<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>} />;
export const Aviso = () => <StaticPage title="Aviso Legal" content={<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>} />;
export const Contacto = () => (
  <div className="min-h-screen p-6 md:p-12 bg-palette3 text-palette2 max-w-4xl mx-auto">
    <h1 className="text-2xl md:text-3xl font-bold mb-6">Contacto</h1>
    <form className="space-y-4">
      <input type="text" placeholder="Nombre" className="w-full p-3 bg-palette3 border border-palette1 text-palette2 rounded" />
      <input type="email" placeholder="Email" className="w-full p-3 bg-palette3 border border-palette1 text-palette2 rounded" />
      <textarea placeholder="Mensaje" className="w-full p-3 bg-palette3 border border-palette1 text-palette2 rounded h-32" />
      <button className="bg-palette1 text-palette3 px-6 py-2 rounded font-bold">Enviar</button>
    </form>
  </div>
);
